import { FishbowlIcon } from './FishbowlIcon';

/**
 * author: Michael Irigoyen
 * id 50A773A8-4349-4B7F-A211-6CB14E9C090B
 * name fishbowl
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fishbowl.svg
 * tags
 * - Animal 
 */
export const AquariumIcon = FishbowlIcon;
export default AquariumIcon